__turbopack_context__.v({
  "className": "playfair_display_461249ab-module__eBIurq__className",
  "variable": "playfair_display_461249ab-module__eBIurq__variable",
});
